export class GmServerType {
  static get Gm1 () {
    return 1
  }
  static get Gm2 () {
    return 2
  }

  static GmServerTypeName (GmServerType) {
    let tmpType = parseInt(GmServerType)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 1:
        name = 'GM1'
        break
      case 2:
        name = 'GM2'
        break
    }
    return name
  }
}
